import { Fragment } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { BreadCrumb } from "./breadCrumb";

export const NoPermission = () => {
  return (
    <Fragment>
      <BreadCrumb data={[{ name: "Access Denied", url: "" }]} />
      <section className="cart-section">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="no-permission-wrap text-center"
                style={{ padding: "60px 15px", maxWidth: "560px", margin: "0 auto" }}
              >
                <FontAwesomeIcon icon={faLock} style={{ fontSize: "48px", color: "#c0392b", marginBottom: "20px" }} />
                <h1 style={{ marginBottom: "12px" }}>Access Denied</h1>
                <p style={{ marginBottom: "24px" }}>
                  You don't have permission to access this page. Please contact your account administrator if you
                  believe this is a mistake.
                </p>
                <div className="button-effect">
                  <Link to="/home" className="btn btn-products btn-addcart green-btn">
                    Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
